import { render, staticRenderFns } from "./EquipmentDetail1.vue?vue&type=template&id=706cdbfd&scoped=true&"
import script from "./EquipmentDetail1.vue?vue&type=script&lang=js&"
export * from "./EquipmentDetail1.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentDetail1.vue?vue&type=style&index=0&id=706cdbfd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706cdbfd",
  null
  
)

export default component.exports